const awsconfig = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://stqfjihqc5hodh6ivso6vsluou.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AWS_IAM',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:9fe8c124-2848-4663-a79c-5401907c7bcb',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_Ds4vZbsIN',
  'aws_user_pools_web_client_id': 'dtcfucahl993s54amb0hpm2hd',
  'aws_content_delivery_bucket': 'backends-imagebucket6194e37c-1prkbyw78k4tb',
  'aws_content_delivery_bucket_region': 'ap-northeast-1',
  'aws_content_delivery_url': 'http://backends-imagebucket6194e37c-1prkbyw78k4tb.s3-website-ap-northeast-1.amazonaws.com',
  'oauth': {}
}
export default awsconfig
